export enum MEASURE_UNIT_FACADE_SYSTEM_VARIATION {
  mm = 'mm',
}

export enum MEASURE_UNIT_FACADE_SYSTEM_TIEFE {
  mm = 'mm',
}
